export const sourceSystemDefaultRedirectLookup = {
    '1': '/customer/template',
    '2': '/finance/services',
    '3': '/titleregistration/template',
    '4': '/driver/services',
    '7': '/compliance/services',
    '9': 'case',
    '10': '/collections/services',
    '11': '/irp/services',
    '12': '/commercialpermitting/services',
    '14': '/aircraft/services'
};
